// import { useTheme } from '@material-ui/core';
// import { UrlQueryKey } from 'app/core/api/api-core/api-constants';
import {
  useIdentity,
  useSetRepairersActivity,
} from 'app/core/api/company/api-company';
import { PageDetails } from 'app/core/api/company/api-company.types';
// import { useRepairStats } from 'app/core/api/stats/api-stats';
// import {
//   RepairStats,
//   SingleMetric,
// } from 'app/core/api/stats/api-stats.types';
// import { useViewport } from 'app/shared/context-hooks/use-viewport.hook';
import { TileContainer } from 'app/shared/frames/Tile';
// import TileCardButton from 'app/shared/frames/TileCardButton';
import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
// import { ChatFilterKey } from 'app/shared/pages/Chat/ChatList';
// import SharedRoutePath from 'app/shared/SharedRoutePath';
// import styledConsts from 'app/styles/styledConsts';
// import styledFuncs from 'app/styles/styledFuncs';
// import styledMixins from 'app/styles/styledMixins';
// import _ from 'lodash';
// import { DateTime } from 'luxon';
// import { Bar } from 'react-chartjs-2';
import { Redirect } from 'react-router-dom';
// import styled from 'styled-components/macro';
// import { ConditionalPick } from 'type-fest';
import { useEffectOnce } from 'app/tools/hooks/misc-hooks';
import BusinessRoutePath from '../BusinessRoutePath';
import Products from './business-profile/Products';
import RequestsOverTime from './business-profile/RequestsOverTime';

// type MetricOpts = {
//   $spx: (x: number) => string;
// };
// const MetricSubtitle = styled(Body)<MetricOpts>`
//   font-size: ${p => p.$spx(11)};
//   font-style: italic;
//   color: #9e9e9e;
// `;
// type MetricNumberOpts = MetricOpts & {
//   $noMetric: boolean;
// };
// const MetricNumber = styled.div<MetricNumberOpts>`
//   color: ${styledConsts.cPrimary};
//   ${styledMixins.absoluteCentered}
//   ${styledMixins.flexCenter}
//   line-height: 1.2;
//   font-weight: 600;
//   text-align: center;

//   font-size: ${p => p.$spx(p.$noMetric ? 14 : 55)};
//   opacity: ${p => (p.$noMetric ? 0.6 : 1)};
//   width: ${p => (p.$noMetric ? '70%' : 'auto')};
// `;

// const StyledTileCardButton = styled(TileCardButton)`
//   .MuiButton-label > div {
//     padding: ${styledFuncs.pad()};
//     flex-direction: column;
//   }
// `;

// const NakedTileCardButton = styled(StyledTileCardButton)`
//   margin: ${styledFuncs.pad()};
//   height: auto;
// `;

// type SingleMetricKey = keyof ConditionalPick<
//   RepairStats,
//   SingleMetric
// >;
// type MetricLink = `${typeof metricLinkPrefix}=${ChatFilterKey}`;
// type MetricInfo = { key: SingleMetricKey; href?: MetricLink };

// const metricLinkPrefix =
//   `${SharedRoutePath.CHAT_LIST}?${UrlQueryKey.FILTER_CATEGORY}` as const;

// const singleMetricsInfo: MetricInfo[] = [
//   { key: 'resolvedCases', href: `${metricLinkPrefix}=completed` },
//   { key: 'openCases', href: `${metricLinkPrefix}=new` },
//   {
//     key: 'repairsInProgress',
//     href: `${metricLinkPrefix}=inProgress`,
//   },
//   { key: 'percentageRepairSuccess' },
// ];

// const subGroup = /\(.*\)/;
// const noDataMsg = 'No data available yet';

// type MetricTileProps = {
//   metric: SingleMetric & MetricInfo;
//   /** Returns pixel value, scaled by screen size. Based from iPhone width */
//   spx: (x: number) => string;
// };
// function MetricTile({
//   metric: { statType, statTitle, number, href },
//   spx: $spx,
// }: MetricTileProps): JSX.Element {
//   const history = useHistory();

//   const noMetric = statType === 'unavailable';
//   const statTitleMain = statTitle.replace(subGroup, '');
//   const statTitleSub = statTitle.match(subGroup)?.[0];
//   return (
//     <Tile>
//       <StyledTileCardButton
//         onClick={href ? () => history.push(href) : undefined}
//         noClickAction={!href}
//       >
//         <MetricTitle {...{ $spx }}>{statTitleMain}</MetricTitle>
//         <MetricSubtitle {...{ $spx }}>{statTitleSub}</MetricSubtitle>
//         <MetricNumber $noMetric={noMetric} {...{ $spx }}>
//           {noMetric ? noDataMsg : number.toFixed()}
//           {!noMetric && statTitleSub?.includes('percentage') && '%'}
//         </MetricNumber>
//       </StyledTileCardButton>
//     </Tile>
//   );
// }

export default function Home(): JSX.Element {
  // const theme = useTheme();
  const { resource: { company } = {}, loading } = useIdentity();
  // const { resource: stats } = useRepairStats();
  const { request$: repairActivity } = useSetRepairersActivity();
  useEffectOnce(() => {
    const pageDetails: PageDetails = {
      pagename: 'Home',
    };
    repairActivity(pageDetails).subscribe();
  });

  // const singleMetrics =
  //   stats &&
  //   _(singleMetricsInfo)
  //     .filter(info => _.keys(stats).includes(info.key))
  //     .map(info => ({ ...info, ...stats[info.key] }))
  //     .value();

  // const { casesOverTime } = stats || {};
  // const seriesData = casesOverTime?.series.map(({ count, date }) => ({
  //   date: DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd MMM'),
  //   count, // : _.random(10),
  // }));
  // const noSeriesDataEntries = _.map(seriesData, 'count').every(
  //   count => count === 0
  // );

  // const defaultWidth = 375; // px
  // const { vWidth } = useViewport();
  // const widthSizer = Math.min(vWidth, 420);
  /** Returns pixel value, scaled by screen size. Based from iPhone width */
  // const spx = (x: number) =>
  //   `${(x * widthSizer ** 0.8) / defaultWidth ** 0.8}px`;

  const loadingComplete = !!company || !loading;
  if (loadingComplete && !company) {
    return <Redirect to={BusinessRoutePath.NEW_USER_INTRO} />;
  }

  return (
    <>
      <LoadingOverlay frame="outer" {...{ loadingComplete }} />
      <TileContainer>
        <Products />
        {/* {singleMetrics?.map(metric => (
          <MetricTile key={metric.statTitle} {...{ metric, spx }} />
        ))} */}
        <RequestsOverTime />
        {/* {seriesData && (
          <div style={{ width: '96%' }}>
            <h3 style={{ color: '#31AD31', fontWeight: 500 }}>
              Requests over time
            </h3>
            <div>
              <NakedTileCardButton noClickAction>
                {noSeriesDataEntries && (
                  <MetricNumber $spx={spx} $noMetric>
                    {noDataMsg}
                  </MetricNumber>
                )}
                <Bar
                  data={{
                    datasets: [
                      {
                        type: 'bar',
                        data: seriesData,
                        backgroundColor: styledConsts.cPrimary({
                          theme,
                        }),
                      },
                    ],
                  }}
                  options={{
                    parsing: {
                      xAxisKey: 'date',
                      yAxisKey: 'count',
                    },
                    plugins: {
                      legend: { display: false },
                    },
                    scales: {
                      y: { ticks: { precision: 0 } },
                    },
                  }}
                />
              </NakedTileCardButton>
            </div>
          </div>
        )} */}
      </TileContainer>
    </>
  );
}
